<template>
  <b-modal id="change-password" ref="changePassword" v-model="value" size="xxl"
    :title="resource['changePassword.Title']" title-tag="h2" hide-footer body-class="p-0" :centered="true"
    @hidden="hide">
    <validation-observer ref="changePasswordObserver" v-slot="{ passes,invalid }">
      <b-form @submit.prevent="passes(check)" @reset.prevent="hide">
        <div class="p-3">
          <validate-form ref="oldPassword" v-model="oldPasswordConfig.value" type="password" :rules="rulesOldPassword"
            :label-form="resource['changePassword.OldPassword'] + '*'" :name="resource['changePassword.OldPassword']"
            @keypress="maxLengthCheck($event, 20, 'oldPassword')"
            @keyup="maxLengthCheck($event, 20, 'oldPassword')"
            @focus="showCriterion = false"
            placeholder="******"
            id="oldPassword"
            />

           <div class="newPasswordContainer position-relative mb-20 mt-20">
          <validate-form   ref="newPassword" v-model="passwordValue"   :type="showPassword ? 'text' : 'password'"
            :label-form="resource['changePassword.NewPassword'] + '*'"
            name="newPassword"
            @keypress="maxLengthCheck($event, 20, 'confirmPassword')"
            @keyup="maxLengthCheck($event, 20, 'confirmPassword')"
            @focus="showCriterion = true"
            id="newPassword"
            placeholder="******"
            />
            <h5
            class="show-password"
            :style="!passwordValue && 'cursor: initial'"
            @click="showPasswordAction"
          >
            <img v-if="showPassword" :src="require('@/assets/images/hidden-password.svg')" />
            <img
              v-else
              :src="require('@/assets/images/show-password.svg')"
            />
          </h5>
          <transition name="slide"
      >
            <div v-if="showCriterion"  class="case-control-container position-relative">
              <div :class="['xs mb-6 d-flex align-items-center', {
                'text-color-dark-mint': passwordValidation.hasValidCount,
              }]">
                <i class=" align-middle  mr-1" v-if="!passwordValidation.hasValidCount">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.99935 8.33335C6.8403 8.33335 8.33268 6.84097 8.33268 5.00002C8.33268 3.15907 6.8403 1.66669 4.99935 1.66669C3.1584 1.66669 1.66602 3.15907 1.66602 5.00002C1.66602 6.84097 3.1584 8.33335 4.99935 8.33335Z"
                      fill="#383D41" />
                  </svg>
                </i>
                <i class=" align-middle  mr-1" v-if="passwordValidation.hasValidCount">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.66745 6.62706L2.20911 5.16873C2.04661 5.00623 1.78828 5.00623 1.62578 5.16873C1.46328 5.33123 1.46328 5.58956 1.62578 5.75206L3.37161 7.4979C3.53411 7.6604 3.79661 7.6604 3.95911 7.4979L8.37578 3.0854C8.53828 2.9229 8.53828 2.66456 8.37578 2.50206C8.21328 2.33956 7.95495 2.33956 7.79245 2.50206L3.66745 6.62706Z"
                      fill="#49CA77" />
                  </svg>
                </i>
                {{ resource['profile.ChangePasswordModalCaseFour'] }}
              </div>

              <div :class="['xs mb-6 d-flex align-items-center', {
                'text-color-dark-mint': passwordValidation.hasNumber,
              }]">
                <i class=" align-middle  mr-1" v-if="!passwordValidation.hasNumber">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.99935 8.33335C6.8403 8.33335 8.33268 6.84097 8.33268 5.00002C8.33268 3.15907 6.8403 1.66669 4.99935 1.66669C3.1584 1.66669 1.66602 3.15907 1.66602 5.00002C1.66602 6.84097 3.1584 8.33335 4.99935 8.33335Z"
                      fill="#383D41" />
                  </svg>
                </i>
                <i class=" align-middle  mr-1" v-if="passwordValidation.hasNumber">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.66745 6.62706L2.20911 5.16873C2.04661 5.00623 1.78828 5.00623 1.62578 5.16873C1.46328 5.33123 1.46328 5.58956 1.62578 5.75206L3.37161 7.4979C3.53411 7.6604 3.79661 7.6604 3.95911 7.4979L8.37578 3.0854C8.53828 2.9229 8.53828 2.66456 8.37578 2.50206C8.21328 2.33956 7.95495 2.33956 7.79245 2.50206L3.66745 6.62706Z"
                      fill="#49CA77" />
                  </svg>
                </i>
                {{ resource['profile.ChangePasswordModalCaseOne'] }}
              </div>

              <div :class="['xs mb-6 d-flex align-items-center', {
                'text-color-dark-mint': passwordValidation.hasUpperCase,
              }]">
              <i class=" align-middle  mr-1" v-if="!passwordValidation.hasUpperCase">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.99935 8.33335C6.8403 8.33335 8.33268 6.84097 8.33268 5.00002C8.33268 3.15907 6.8403 1.66669 4.99935 1.66669C3.1584 1.66669 1.66602 3.15907 1.66602 5.00002C1.66602 6.84097 3.1584 8.33335 4.99935 8.33335Z"
                    fill="#383D41" />
                </svg>
              </i>
              <i class=" align-middle  mr-1" v-if="passwordValidation.hasUpperCase">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.66745 6.62706L2.20911 5.16873C2.04661 5.00623 1.78828 5.00623 1.62578 5.16873C1.46328 5.33123 1.46328 5.58956 1.62578 5.75206L3.37161 7.4979C3.53411 7.6604 3.79661 7.6604 3.95911 7.4979L8.37578 3.0854C8.53828 2.9229 8.53828 2.66456 8.37578 2.50206C8.21328 2.33956 7.95495 2.33956 7.79245 2.50206L3.66745 6.62706Z"
                    fill="#49CA77" />
                </svg>
              </i>
                {{ resource['profile.ChangePasswordModalCaseTwo'] }}
              </div>

              <div :class="['xs d-flex align-items-center', {
                'text-color-dark-mint': passwordValidation.hasSpecial,
              }]">
              <i class=" align-middle  mr-1" v-if="!passwordValidation.hasSpecial">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.99935 8.33335C6.8403 8.33335 8.33268 6.84097 8.33268 5.00002C8.33268 3.15907 6.8403 1.66669 4.99935 1.66669C3.1584 1.66669 1.66602 3.15907 1.66602 5.00002C1.66602 6.84097 3.1584 8.33335 4.99935 8.33335Z"
                    fill="#383D41" />
                </svg>
              </i>
              <i class=" align-middle mr-1" v-if="passwordValidation.hasSpecial">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.66745 6.62706L2.20911 5.16873C2.04661 5.00623 1.78828 5.00623 1.62578 5.16873C1.46328 5.33123 1.46328 5.58956 1.62578 5.75206L3.37161 7.4979C3.53411 7.6604 3.79661 7.6604 3.95911 7.4979L8.37578 3.0854C8.53828 2.9229 8.53828 2.66456 8.37578 2.50206C8.21328 2.33956 7.95495 2.33956 7.79245 2.50206L3.66745 6.62706Z"
                    fill="#49CA77" />
                </svg>
              </i>
                {{ resource['profile.ChangePasswordModalCaseThree'] }}
              </div>
            </div>
          </transition>
        </div>
          <validate-form ref="newPasswordConfirm" v-model="passwordConfirmValue" type="password"
            :rules="rulesNewConfirmPassword"
            name="newConfirmPassword"
            id="newConfirmPassword"
            @keypress="maxLengthCheck($event, 20, 'newConfirmPassword')"
            @keyup="maxLengthCheck($event, 20, 'newConfirmPassword')"
            @focus="showCriterion = false"
            placeholder="******"
            :label-form="resource['changePassword.NewPasswordConfirm'] + '*'" class-group="position-relative" />

        </div>

        <div class="modal-footer">
          <button class="btn md bg-purple text-white overflow-hidden" :disabled="(invalid || !passwordValidation.hasValidCount || !passwordValidation.hasSpecial || !passwordValidation.hasNumber || !passwordValidation.hasUpperCase)" type="submit">
            <span class="p-2 pr-2" v-if="isLoading" >
              <span :class="{'is-loading' : isLoading }"></span>
            </span>
            <span  v-else > {{ resource['label.Change'] }}</span>
          </button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
<script>
import HrVenueService from '@/services/hrvenue.service';
import AccountService from '@/services/account';

export default {
  name: 'ChangeAccountPassword',
  props: {
    value: {
      type: Boolean,
      required: true,
    },

  },

  data() {
    return {
      currentInputType: 'password',
      currentText: 'label.Show',
      passwordValue: '',
      passwordConfirmValue: '',
      showPassword: false,
      showCriterion: false,
      oldPasswordConfig: {
        name: 'oldPassword',
        value: '',
        minCharCount: 8,
        maxCharCount: 20,
      },
      newPasswordConfig: {
        name: 'newPassword',
        minCharCount: 8,
        maxCharCount: 20,
      },
      passwordValidation: {
        hasNumber: false,
        hasUpperCase: false,
        hasSpecial: false,
        hasValidCount: false,
      },
      status: true,
      isLoading: false,
    };
  },

  computed: {
    rulesOldPassword() {
      const { minCharCount } = this.oldPasswordConfig;
      return `required|min_plain_text: ${minCharCount}`;
    },

    rulesNewPassword() {
      const { minCharCount } = this.newPasswordConfig;
      return `min_plain_text: ${minCharCount}`;
    },
    rulesNewConfirmPassword() {
      const { minCharCount } = this.newPasswordConfig;
      return `required|confirmed:newPassword|min_plain_text: ${minCharCount}`;
    },

  },

  watch: {
    passwordValue() {
      this.validatePassword();
    },
    passwordConfirmValue() {
      this.validatePassword();
    },
    value: {
      handler(newVal) {
        if (!newVal) {
          this.passwordValue = '';
          this.passwordConfirmValue = '';
          this.oldPasswordConfig.value = '';
        }
      },
      deep: true,
    },
  },

  methods: {
    showPasswordAction() {
      this.showPassword = !this.showPassword;
      if (!this.showCriterion) {
        this.showCriterion = true;
      }
    },
    validatePassword() {
      this.passwordValidation.hasNumber = /\d/.test(this.passwordValue);

      this.passwordValidation.hasUpperCase = this.passwordValue.replace(/[^A-Z]/g, '').length > 0;

      this.passwordValidation.hasValidCount = this.passwordValue.length <= 20 && this.passwordValue.length >= 8;

      // eslint-disable-next-line no-useless-escape
      this.passwordValidation.hasSpecial = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.passwordValue);
    },

    hide() {
      this.$emit('input', false);
      this.showCriterion = false;
      this.showPassword = false;
    },

    check() {
      if (
        this.passwordValidation.hasNumber
        && this.passwordValidation.hasUpperCase
        && this.passwordValidation.hasSpecial
      ) {
        this.save();
      }
    },

    setWhichInput(InpEl, value) {
      if (InpEl === 'oldPassword') {
        this.oldPasswordConfig.value = value;
      } else if (InpEl === 'confirmPassword') {
        this.passwordValue = value;
      } else if (InpEl === 'newConfirmPassword') {
        this.passwordConfirmValue = value;
      }
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;
      if (String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },

    async save() {
      this.isLoading = true;
      const { changed } = await HrVenueService.changePassword(
        3,
        this.currentUser.userId,
        null,
        this.oldPasswordConfig.value,
        this.passwordValue,
        this.passwordValue,
      );
      if (changed) {
        localStorage.removeItem('passwordLength');
        localStorage.removeItem('pass');
        AccountService.reset2fa();
        // delete token from cookie
        AccountService.deleteToken();
        // redirect to login page
        window.location.reload();
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">

.slide-enter-active {
  transition: all 0.5s ease;
}
.slide-leave-active {
  display: none;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.case-control-container{
  background: #F5F5F5;
  border-radius: 8px;
  padding: 10px;
  margin-top: 12px;

  &:after {
    content: "";
    position: absolute;
    top: -7px;
    left: 12px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 5px 10px 5px;
    border-color: transparent transparent #f5f5f5 transparent;
  }
}
.show-password {
  position: absolute;
  color: #FF8D06;
  cursor: pointer;
  right: 0px;
  top: 33px;
}

.mb-6{
  margin-bottom: 6px;
}
.mb-20{
  margin-bottom: 20px;
}
.mt-20{
  margin-top: 20px;
}
.is-loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #e6e6e6;
  border-radius: 50%;
  border-top-color: #FF8D06;
  animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
  -webkit-animation:spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
}

@keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
</style>
